import { storeToRefs } from 'pinia'
import type { Workspace } from '@apiTypes'
import { PackageQuotaFlag } from '@/consts/module-quotas'
import { useAuthStore } from '@/stores/auth'

function isPackageFlagEnabledForWorkspace(flag: PackageQuotaFlag, workspace?: Workspace | null): boolean {
  const currentWorkspace = workspace ?? useAuthStore().currentWorkspace

  return currentWorkspace?.packageData?.[flag] ?? false
}

export function isTenderEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isPackageFlagEnabledForWorkspace(PackageQuotaFlag.Tender, workspace)
}

export function isContractMatchingEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isPackageFlagEnabledForWorkspace(PackageQuotaFlag.ContractMatching, workspace)
}

export function isTimeSlotsEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isPackageFlagEnabledForWorkspace(PackageQuotaFlag.TimeSlots, workspace)
}

export function isContractAccessEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isTenderEnabledForWorkspace(workspace) || isContractMatchingEnabledForWorkspace(workspace)
}

export function isVehicleTypesEnabledForWorkspace(workspace?: Workspace | null): boolean {
  return isTenderEnabledForWorkspace(workspace) || isTimeSlotsEnabledForWorkspace(workspace)
}

export function useModuleQuotas() {
  const { currentWorkspace } = storeToRefs(useAuthStore())

  const isTenderEnabled = computed(() => isTenderEnabledForWorkspace(currentWorkspace.value))
  const isContractAccessEnabled = computed(() => isContractAccessEnabledForWorkspace(currentWorkspace.value))
  const isTimeSlotsEnabled = computed(() => isTimeSlotsEnabledForWorkspace(currentWorkspace.value))
  const isVehicleTypesEnabled = computed(() => isVehicleTypesEnabledForWorkspace(currentWorkspace.value))

  return { isTenderEnabled, isContractAccessEnabled, isTimeSlotsEnabled, isVehicleTypesEnabled }
}
